import {
  AppointmentsModel
} from "one-card-appointments-table";

import {
  AppointmentData
} from 'one-model-local';

import { getday } from 'one-util-date';

/**
* This Function transforms the backend response
* in the Data Model that supports the 
* Appointments Component
* @param response has the backend 
* appointment response
* @param context has settings etc..
*/
//ADPAC-426
function sortFunction(a: AppointmentData, b: AppointmentData) {
  const dateA = new Date(a.date).getTime();
  const dateB = new Date(b.date).getTime();
  return dateA > dateB ? 1 : -1;
}

export const TransformResponse = (response: any, context: any, patientId: string) => {
  /**
   * @param result contains the transformed response
   */
  let result: AppointmentsModel = {};
  let dataarray: any = [];
  const { settings } = context ? context:"";
  const {uisettings:{dateformat}} = settings ? settings:{uisettings:""};
  const { settings:{appointment_config:{filterAppointments}}} = context;
  if (response && response.length > 0) {
      response.map((ele: any, index:number) => {
          let presentdate: number = new Date().getTime();
          let ddate: string = ele.appointmentDate ? ele.appointmentDate.split('T')[0] : "";
          let dtime: string = ele.appointmentDate ? ele.appointmentDate .split('T')[1]: "";
          let apptdate: number = new Date(ddate.concat(" ").concat(dtime)).getTime();
          function formatDateTimeWithAMPM(dateTimeStr:any) {
              // Parse the string into a Date object
              const dateTime = new Date(dateTimeStr);

              // Extract date components
              const month = dateTime.getMonth() + 1;
              const day = dateTime.getDate();
              const year = dateTime.getFullYear();

              // Extract time components
              const hours = dateTime.getHours();
              const minutes = dateTime.getMinutes();
              const seconds = dateTime.getSeconds();
          
              // Determine AM/PM
              const amPM = hours >= 12 ? 'PM' : 'AM';
              const displayHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour clock
          
              // Format the date and time with AM/PM indication
              const formattedTime = `${displayHours}:${minutes}:${seconds} ${amPM}`;
              const formattedDate = `${month}-${day}-${year}`;

              return [formattedDate,formattedTime]
          }
          let data: AppointmentData = {
              key: "",
              date: "",
              department: "",
              departmentId: "",
              appointmentTime: "",
              provider: "",
              providerId: "",
              status: "",
              visitType: "",
              visitTypeID: "",
              appointmentType: "",
              appointmentDuration: "",
              patientId: "",
              patientName: "",
              patientIDType: "",
              contactID: "",
              contactIDType: "",
              day: "",
              AppointmentNotes:"",
              ArrivalTime:"",
              resource:"",
              location:"",
              event:"",
          };
          data.key = index.toString();
          if (presentdate <= apptdate) {
              data.appointmentType = "future";
              data.status = "future";
          }
          if (presentdate > apptdate) {
              data.appointmentType = "past";
              data.status = "past";
          }
          if(ele.isCancelled === true) {
              data.appointmentType = "canceled";
              data.status = "canceled";
          }
          if(ele.isNoShow === true) {
            data.appointmentType = "noshows";
            data.status = "noshows";
          }
          if(ele.isKept === true) {
            ///confirm apt
          }
          // if (ele.Providers && ele.Providers.length > 0) {
          //     data.department = ele.Providers[0]?.DepartmentName ? ele.Providers[0].DepartmentName:"";
          //     data.provider = ele.Providers[0]?.ProviderName ? ele.Providers[0].ProviderName : "";

          //     if(filterAppointments["epic"][0]["configuredProviderId"].length>0){
          //         let keys=filterAppointments["epic"][0]["configuredProviderId"]
          //         let values=ele.Providers[0]?.ProviderIDs.length>0?ele.Providers[0]?.ProviderIDs:[]
          //         if(values.length>0){
          //             for(var i=0;i<values.length;i++){
          //                 if(keys.includes(values[i].ID.trim())){
          //                     data.providerId= values[i].ID
          //                     break;
          //                 }
          //             }
          //         }
          //     }
          //     else if(filterAppointments["epic"][1]["configuredDeptId"].length>0){
          //         let keys=filterAppointments["epic"][1]["configuredDeptId"]
          //         let values=ele.Providers[0]?.DepartmentIDs.length>0?ele.Providers[0]?.DepartmentIDs:[]
          //         if(values.length>0){
          //             for(var i=0;i<values.length;i++){
          //                 if(keys.includes(values[i].ID.trim())){
          //                     data.departmentId= values[i].ID
          //                     break;
          //                 }
          //             }
          //         }
          //     }
          //     else{
          //         data.providerId = ele.Providers[0]?.ProviderIDs?.[0]?.ID ? ele.Providers[0].ProviderIDs[0].ID:"";
          //         data.departmentId = ele.Providers[0]?.DepartmentIDs?.[0]?.ID ? ele.Providers[0].DepartmentIDs[0].ID:"";
          //     }
          // }
          data.date = ddate ? formatDateTimeWithAMPM(ele.appointmentDate)[0] : "";
          data.day = ele.appointmentDate ? getday(ele.Date) : "";
          data.status = ele.appointmentType ? ele.appointmentType : "";
          data.visitType = ele.eventName ? ele.eventName : "";
          data.appointmentTime = dtime ? formatDateTimeWithAMPM(ele.appointmentDate)[1] : "";
          data.patientId = patientId ? patientId:"";
          data.patientIDType = context?.settings?.epicendpoints?.searchID ? context.settings.epicendpoints.searchID:"";
          data.patientName = ele.firstName ? ele.firstName:"";
          data.resource=ele.resourceDisplayName?ele.resourceDisplayName:"";
          data.location=ele.locationName?ele.locationName:"";
          data.event=ele.eventName?ele.eventName:"";
          // data.appointmentDuration = ele.AppointmentDuration ? ele.AppointmentDuration:"";
          // data.ArrivalTime = ele.ArrivalTime ? ele.ArrivalTime:"";
          // if(ele.ContactIDs && ele.ContactIDs.length > 0){
          //     data.contactID = ele.ContactIDs[0]?.ID ? ele.ContactIDs[0].ID:"";
          //     data.contactIDType = ele.ContactIDs[0]?.Type ? ele.ContactIDs[0].Type:"";
          // }
          // if(ele.VisitTypeIDs && ele.VisitTypeIDs.length > 0){
          //     // data.visitTypeID = ele.VisitTypeIDs[0]?.ID ? ele.VisitTypeIDs[0].ID:"";
          //     if(filterAppointments["epic"][2]["configuredVisitId"].length>0){
          //         let keys=filterAppointments["epic"][2]["configuredVisitId"]
          //         let values=ele.VisitTypeIDs.length>0?ele.VisitTypeIDs:[]
          //         if(values.length>0){
          //             for(var i=0;i<values.length;i++){
          //                 if(keys.includes(values[i].ID.trim())){
          //                     data.visitTypeID= values[i].ID
          //                     break;
          //                 }
          //             }
          //         }
          //     }
          //     else{
          //         data.visitTypeID = ele.VisitTypeIDs[0]?.ID ? ele.VisitTypeIDs[0].ID:"";

          //     }
          // }
          // data.AppointmentNotes=ele.AppointmentNotes.length>0?ele.AppointmentNotes[0]:''
          dataarray.push(data);
          //ADPAC-426
          dataarray.sort(sortFunction);
      });
      result['data'] = dataarray;
  }
  return result;


}